import { styled } from '@material-ui/core/styles';

export const Container = styled('div')(({ theme, background }) => ({
  height: '85vh',
  width: '100%',
  background: `${theme.palette.background.secondary} url("${background[0]}") no-repeat top right`,
  backgroundSize: '100vh',
  display: 'grid',
  gridTemplateColumns: 'minmax(100px, auto) 1280px minmax(100px, auto)',
  gridTemplateRows: '65% 35%',
  gridTemplateAreas: `"left right"
      "left bottom"`,
  alignItems: 'center',
  [theme.breakpoints.down('1367')]: {
    gridTemplateColumns: 'minmax(100px, auto) 1200px minmax(100px, auto)',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '10% 85%',
    backgroundSize: 'cover',
    background: `white url("${
      background[1] ? background[1] : background[0]
    }") no-repeat top center`,
  },
  [theme.breakpoints.down('sm')]: {
    height: '83vh',
    background: `white url("${
      background[1] ? background[1] : background[0]
    }") no-repeat top center`,
    backgroundSize: 'cover',
    gridTemplateColumns: '8% 83%',
    gridTemplateRows: '80% 30%',
  },
  [theme.breakpoints.down('380')]: {
    gridTemplateColumns: '0% 100%',
  },
}));

export const Social = styled('div')(({ theme }) => ({
  height: '30%',
  gridArea: 'left',
  '& .social': {
    height: '80%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));

export const Content = styled('div')(({ theme }) => ({
  gridArea: 'right',
  height: '100%',
  width: '100%',
  display: 'grid',
  alignItems: 'center',
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    width: '55%',
    paddingTop: '5rem',
    paddingLeft: '5rem',
    alignItems: 'start',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const Presentation = styled('div')(({ theme, inverttitle }) => ({
  width: '45%',
  display: 'flex',
  flexDirection: inverttitle ? 'column-reverse' : 'column',
  [theme.breakpoints.down('lg')]: {
    width: '33%',
  },
}));
